// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Live Training settings — viewport-aware sheet for phone portrait/landscape.
   Sizes to the visual viewport (--lt-vvh) so the browser chrome does not clip
   the dialog when the address bar is visible. */

.lt-settings-dialog.MuiDialog-root {
  /* Sit above live chrome; portal may be .lt-page.
     MUI uses position:fixed → pin to the visual viewport so the browser
     address bar does not clip the sheet in portrait or landscape. */
  z-index: 13000;
  top: var(--lt-vvt, 0px) !important;
  left: var(--lt-vvl, 0px) !important;
  right: auto !important;
  bottom: auto !important;
  width: var(--lt-vvw, 100%) !important;
  height: var(--lt-vvh, 100dvh) !important;
  max-height: var(--lt-vvh, 100dvh) !important;
}

.lt-settings-dialog .MuiDialog-container {
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
  height: 100%;
  max-height: 100%;
  width: 100%;
  padding:
    max(6px, env(safe-area-inset-top, 0px))
    max(8px, env(safe-area-inset-right, 0px))
    max(6px, env(safe-area-inset-bottom, 0px))
    max(8px, env(safe-area-inset-left, 0px));
}

.lt-settings-dialog--landscape .MuiDialog-container {
  align-items: center;
  padding:
    max(4px, env(safe-area-inset-top, 0px))
    max(10px, env(safe-area-inset-right, 0px))
    max(4px, env(safe-area-inset-bottom, 0px))
    max(10px, env(safe-area-inset-left, 0px));
}

.lt-settings-dialog .MuiPaper-root.lt-settings-dialog__paper,
.lt-settings-dialog .lt-settings-dialog__paper {
  --lt-settings-gap: 12px;
  --lt-brand: var(--brand-primary, #0877bc);
  --lt-brand-secondary: var(--brand-secondary, #46528b);
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: min(520px, 100%);
  margin: 0 !important;
  /* Fit inside the remaining visible screen, including when browser bar shows. */
  height: auto;
  max-height: calc(100% - 8px);
  min-height: 0;
  overflow: hidden;
  border-radius: 18px 18px 12px 12px;
  box-sizing: border-box;
  background: linear-gradient(
    165deg,
    #0f172a 0%,
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 18%, #1e293b) 50%,
    #0f172a 100%
  );
  color: #f8fafc;
  border: 1px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 32%, rgba(255, 255, 255, 0.12));
  box-shadow: 0 -12px 36px rgba(0, 0, 0, 0.42);
}

.lt-settings-dialog--landscape .lt-settings-dialog__paper {
  --lt-settings-gap: 8px;
  max-width: min(640px, 100%);
  max-height: calc(100% - 4px);
  border-radius: 14px;
}

/* Very short landscape (browser bar + notch) — tighter sheet */
@media (orientation: landscape) and (max-height: 420px) {
  .lt-settings-dialog .lt-settings-dialog__paper {
    --lt-settings-gap: 6px;
    max-height: calc(var(--lt-vvh, 100dvh) - 4px);
    border-radius: 12px;
  }

  .lt-settings-dialog__title.MuiDialogTitle-root {
    padding: 10px 14px 6px !important;
  }

  .lt-settings-dialog__subtitle {
    display: none;
  }

  .lt-settings-dialog__content.MuiDialogContent-root {
    padding: 4px 14px 8px !important;
  }

  .lt-settings-dialog__actions.MuiDialogActions-root {
    padding: 6px 10px calc(6px + env(safe-area-inset-bottom, 0px)) !important;
  }

  .lt-settings-dialog__section + .lt-settings-dialog__section {
    margin-top: 12px;
    padding-top: 10px;
  }

  .lt-settings-dialog__hint {
    font-size: 11.5px;
  }
}

.lt-settings-dialog__title.MuiDialogTitle-root {
  flex: 0 0 auto;
  margin: 0;
  padding: 14px 16px 8px;
  font-size: 1.1rem;
  font-weight: 750;
  letter-spacing: -0.01em;
  line-height: 1.25;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-settings-dialog__subtitle {
  display: block;
  margin-top: 4px;
  font-size: 12.5px;
  font-weight: 500;
  opacity: 0.72;
  line-height: 1.35;
}

.lt-settings-dialog__content.MuiDialogContent-root {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 10px 16px 12px !important;
  /* Avoid MUI's first-child padding jump */
  padding-top: 10px !important;
}

.lt-settings-dialog__actions.MuiDialogActions-root {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin: 0;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(15, 23, 42, 0.92);
  backdrop-filter: blur(8px);
}

.lt-settings-dialog__actions .MuiButton-root {
  min-height: 40px;
  text-transform: none;
  font-weight: 650;
}

.lt-settings-dialog__section {
  margin-top: 2px;
}

.lt-settings-dialog__section + .lt-settings-dialog__section {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-settings-dialog__section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 var(--lt-settings-gap, 12px);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--lt-brand, #0877bc) 65%, #f8fafc);
}

.lt-settings-dialog__section-title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 14px;
  border-radius: 999px;
  background: var(--lt-brand, #0877bc);
}

.lt-settings-dialog__subsection {
  padding: 10px 10px 6px;
  margin: 0 0 12px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 12%, rgba(15, 23, 42, 0.35));
  border: 1px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 22%, rgba(255, 255, 255, 0.08));
}

.lt-settings-dialog__subsection:last-child {
  margin-bottom: 0;
}

.lt-settings-dialog__subsection-title {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #f8fafc);
}

.light-mode .lt-settings-dialog__subsection,
html[data-theme="light"] .lt-settings-dialog__subsection {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 5%, #ffffff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 20%, #cbd5e1);
}

.light-mode .lt-settings-dialog__subsection-title,
html[data-theme="light"] .lt-settings-dialog__subsection-title {
  color: var(--lt-brand, #0877bc);
}

.lt-settings-dialog .MuiSwitch-switchBase.Mui-checked {
  color: var(--lt-brand, #0877bc) !important;
}

.lt-settings-dialog .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  background-color: var(--lt-brand, #0877bc) !important;
}

.lt-settings-dialog__switch {
  align-items: flex-start !important;
  margin: 0 0 var(--lt-settings-gap, 12px) !important;
  width: 100%;
  gap: 4px;
}

.lt-settings-dialog__switch .MuiFormControlLabel-label {
  margin-left: 2px;
  min-width: 0;
}

.lt-settings-dialog__switch .MuiSwitch-root {
  margin-top: -2px;
}

.lt-settings-dialog__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 2px;
}

.lt-settings-dialog__field + .lt-settings-dialog__field {
  margin-top: 14px;
}

.lt-settings-dialog__field--disabled {
  opacity: 0.45;
  pointer-events: none;
}

.lt-settings-dialog__label {
  font-size: 14px;
  font-weight: 650;
}

.lt-settings-dialog__hint {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.35;
  opacity: 0.75;
}

.lt-settings-dialog__select {
  appearance: none;
  width: 100%;
  max-width: 100%;
  margin-top: 2px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid
    color-mix(in srgb, var(--lt-brand, #0877bc) 32%, rgba(255, 255, 255, 0.18));
  background: rgba(15, 23, 42, 0.6);
  color: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-sizing: border-box;
}

.lt-settings-dialog__select:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--lt-brand, #0877bc) 75%, #fff);
  outline-offset: 2px;
}

.lt-settings-dialog__select:disabled {
  cursor: not-allowed;
}

.lt-settings-dialog__table-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.lt-settings-dialog__table-chip {
  position: relative;
  min-width: 44px;
  height: 40px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px dashed
    color-mix(in srgb, var(--lt-brand, #0877bc) 40%, rgba(255, 255, 255, 0.28));
  background: rgba(15, 23, 42, 0.45);
  color: rgba(248, 250, 252, 0.78);
  font: inherit;
  font-size: 15px;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.lt-settings-dialog__table-chip:active {
  transform: scale(0.96);
}

.lt-settings-dialog__table-chip:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--lt-brand, #0877bc) 75%, #fff);
  outline-offset: 2px;
}

.lt-settings-dialog__table-chip.is-on {
  border-style: solid;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #ffffff);
  background: var(--lt-brand, #0877bc);
  color: #fff;
  box-shadow: 0 2px 8px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);
}

.lt-settings-dialog__table-chip.is-main {
  border-color: #facc15;
  box-shadow: 0 0 0 1px rgba(250, 204, 21, 0.45);
}

.lt-settings-dialog__table-chip.is-main::after {
  content: "★";
  position: absolute;
  top: 1px;
  right: 4px;
  font-size: 9px;
  color: #facc15;
}

.lt-settings-dialog__table-chip--all {
  border-style: solid;
  font-size: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.lt-settings-dialog__forced-banner {
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, transparent);
  font-size: 12.5px;
  line-height: 1.4;
}

.lt-settings-dialog__actions .MuiButton-contained {
  background: var(--lt-brand, #0877bc) !important;
  color: #ffffff !important;
}

/* Light mode — Live Training settings */
.light-mode .lt-settings-dialog .lt-settings-dialog__paper,
html[data-theme="light"] .lt-settings-dialog .lt-settings-dialog__paper {
  background: linear-gradient(
    165deg,
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 8%, #f8fafc) 0%,
    #ffffff 55%,
    #f1f5f9 100%
  );
  color: #0f172a;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 24%, #cbd5e1);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);
}

.light-mode .lt-settings-dialog__title.MuiDialogTitle-root,
.light-mode .lt-settings-dialog__section + .lt-settings-dialog__section,
html[data-theme="light"] .lt-settings-dialog__title.MuiDialogTitle-root,
html[data-theme="light"] .lt-settings-dialog__section + .lt-settings-dialog__section {
  border-color: rgba(15, 23, 42, 0.1);
}

.light-mode .lt-settings-dialog__section-title,
html[data-theme="light"] .lt-settings-dialog__section-title {
  color: var(--lt-brand, #0877bc);
}

.light-mode .lt-settings-dialog__select,
html[data-theme="light"] .lt-settings-dialog__select {
  background: #ffffff;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-settings-dialog__table-chip:not(.is-on),
html[data-theme="light"] .lt-settings-dialog__table-chip:not(.is-on) {
  background: #f8fafc;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, #cbd5e1);
  color: #334155;
}

.light-mode .lt-settings-dialog__actions.MuiDialogActions-root,
html[data-theme="light"] .lt-settings-dialog__actions.MuiDialogActions-root {
  background: rgba(248, 250, 252, 0.94);
  border-top-color: rgba(15, 23, 42, 0.1);
}

.lt-settings-dialog__fields-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  align-items: start;
}

.lt-settings-dialog__fields-row > .lt-settings-dialog__field {
  margin-top: 0;
}

.lt-settings-dialog__fields-row > .lt-settings-dialog__field + .lt-settings-dialog__field {
  margin-top: 0;
}

@media (min-width: 520px) {
  .lt-settings-dialog__fields-row {
    grid-template-columns: 1fr 1fr;
    gap: 12px 16px;
  }
}

/* Narrow phones / short portrait — keep actions reachable */
@media (max-width: 380px), (max-height: 560px) and (orientation: portrait) {
  .lt-settings-dialog__title.MuiDialogTitle-root {
    padding: 12px 14px 6px;
    font-size: 1.02rem;
  }

  .lt-settings-dialog__content.MuiDialogContent-root {
    padding: 8px 14px 10px !important;
  }

  .lt-settings-dialog__actions.MuiDialogActions-root {
    padding: 8px 10px calc(8px + env(safe-area-inset-bottom, 0px));
  }

  .lt-settings-dialog__actions .MuiButton-root {
    min-height: 38px;
    padding-left: 12px;
    padding-right: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingSettingsDialog.css"],"names":[],"mappings":"AAAA;;gDAEgD;;AAEhD;EACE;;oEAEkE;EAClE,cAAc;EACd,kCAAkC;EAClC,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;EACrC,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX;;;;4CAI0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB;;;;6CAI2C;AAC7C;;AAEA;;EAEE,uBAAuB;EACvB,yCAAyC;EACzC,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,+EAA+E;EAC/E,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB;;;;;GAKC;EACD,cAAc;EACd;+EAC6E;EAC7E,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE;IACE,sBAAsB;IACtB,6CAA6C;IAC7C,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yEAAyE;EAC3E;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,kCAAkC;EAClC,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,gEAAgE;EAChE,8CAA8C;EAC9C,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,8FAA8F;EAC9F;+EAC6E;AAC/E;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;;EAEE,oEAAoE;EACpE,uEAAuE;AACzE;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,mDAAmD;EACnD,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB;+EAC6E;EAC7E,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yEAAyE;EACzE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB;+EAC6E;EAC7E,kCAAkC;EAClC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yEAAyE;EACzE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uEAAuE;EACvE,oCAAoC;EACpC,WAAW;EACX,mFAAmF;AACrF;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+EAA+E;EAC/E,yEAAyE;EACzE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;;EAEE;;;;;GAKC;EACD,cAAc;EACd,uEAAuE;EACvE,8CAA8C;AAChD;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,mBAAmB;EACnB,uEAAuE;EACvE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,uEAAuE;EACvE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,8BAA8B;IAC9B,cAAc;EAChB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,8DAA8D;EAChE;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["/* Live Training settings — viewport-aware sheet for phone portrait/landscape.\n   Sizes to the visual viewport (--lt-vvh) so the browser chrome does not clip\n   the dialog when the address bar is visible. */\n\n.lt-settings-dialog.MuiDialog-root {\n  /* Sit above live chrome; portal may be .lt-page.\n     MUI uses position:fixed → pin to the visual viewport so the browser\n     address bar does not clip the sheet in portrait or landscape. */\n  z-index: 13000;\n  top: var(--lt-vvt, 0px) !important;\n  left: var(--lt-vvl, 0px) !important;\n  right: auto !important;\n  bottom: auto !important;\n  width: var(--lt-vvw, 100%) !important;\n  height: var(--lt-vvh, 100dvh) !important;\n  max-height: var(--lt-vvh, 100dvh) !important;\n}\n\n.lt-settings-dialog .MuiDialog-container {\n  align-items: flex-end;\n  justify-content: center;\n  box-sizing: border-box;\n  height: 100%;\n  max-height: 100%;\n  width: 100%;\n  padding:\n    max(6px, env(safe-area-inset-top, 0px))\n    max(8px, env(safe-area-inset-right, 0px))\n    max(6px, env(safe-area-inset-bottom, 0px))\n    max(8px, env(safe-area-inset-left, 0px));\n}\n\n.lt-settings-dialog--landscape .MuiDialog-container {\n  align-items: center;\n  padding:\n    max(4px, env(safe-area-inset-top, 0px))\n    max(10px, env(safe-area-inset-right, 0px))\n    max(4px, env(safe-area-inset-bottom, 0px))\n    max(10px, env(safe-area-inset-left, 0px));\n}\n\n.lt-settings-dialog .MuiPaper-root.lt-settings-dialog__paper,\n.lt-settings-dialog .lt-settings-dialog__paper {\n  --lt-settings-gap: 12px;\n  --lt-brand: var(--brand-primary, #0877bc);\n  --lt-brand-secondary: var(--brand-secondary, #46528b);\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: min(520px, 100%);\n  margin: 0 !important;\n  /* Fit inside the remaining visible screen, including when browser bar shows. */\n  height: auto;\n  max-height: calc(100% - 8px);\n  min-height: 0;\n  overflow: hidden;\n  border-radius: 18px 18px 12px 12px;\n  box-sizing: border-box;\n  background: linear-gradient(\n    165deg,\n    #0f172a 0%,\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 18%, #1e293b) 50%,\n    #0f172a 100%\n  );\n  color: #f8fafc;\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 32%, rgba(255, 255, 255, 0.12));\n  box-shadow: 0 -12px 36px rgba(0, 0, 0, 0.42);\n}\n\n.lt-settings-dialog--landscape .lt-settings-dialog__paper {\n  --lt-settings-gap: 8px;\n  max-width: min(640px, 100%);\n  max-height: calc(100% - 4px);\n  border-radius: 14px;\n}\n\n/* Very short landscape (browser bar + notch) — tighter sheet */\n@media (orientation: landscape) and (max-height: 420px) {\n  .lt-settings-dialog .lt-settings-dialog__paper {\n    --lt-settings-gap: 6px;\n    max-height: calc(var(--lt-vvh, 100dvh) - 4px);\n    border-radius: 12px;\n  }\n\n  .lt-settings-dialog__title.MuiDialogTitle-root {\n    padding: 10px 14px 6px !important;\n  }\n\n  .lt-settings-dialog__subtitle {\n    display: none;\n  }\n\n  .lt-settings-dialog__content.MuiDialogContent-root {\n    padding: 4px 14px 8px !important;\n  }\n\n  .lt-settings-dialog__actions.MuiDialogActions-root {\n    padding: 6px 10px calc(6px + env(safe-area-inset-bottom, 0px)) !important;\n  }\n\n  .lt-settings-dialog__section + .lt-settings-dialog__section {\n    margin-top: 12px;\n    padding-top: 10px;\n  }\n\n  .lt-settings-dialog__hint {\n    font-size: 11.5px;\n  }\n}\n\n.lt-settings-dialog__title.MuiDialogTitle-root {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 14px 16px 8px;\n  font-size: 1.1rem;\n  font-weight: 750;\n  letter-spacing: -0.01em;\n  line-height: 1.25;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-settings-dialog__subtitle {\n  display: block;\n  margin-top: 4px;\n  font-size: 12.5px;\n  font-weight: 500;\n  opacity: 0.72;\n  line-height: 1.35;\n}\n\n.lt-settings-dialog__content.MuiDialogContent-root {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  padding: 10px 16px 12px !important;\n  /* Avoid MUI's first-child padding jump */\n  padding-top: 10px !important;\n}\n\n.lt-settings-dialog__actions.MuiDialogActions-root {\n  flex: 0 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px;\n  margin: 0;\n  padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(15, 23, 42, 0.92);\n  backdrop-filter: blur(8px);\n}\n\n.lt-settings-dialog__actions .MuiButton-root {\n  min-height: 40px;\n  text-transform: none;\n  font-weight: 650;\n}\n\n.lt-settings-dialog__section {\n  margin-top: 2px;\n}\n\n.lt-settings-dialog__section + .lt-settings-dialog__section {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-settings-dialog__section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 var(--lt-settings-gap, 12px);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: color-mix(in srgb, var(--lt-brand, #0877bc) 65%, #f8fafc);\n}\n\n.lt-settings-dialog__section-title::before {\n  content: \"\";\n  display: inline-block;\n  width: 4px;\n  height: 14px;\n  border-radius: 999px;\n  background: var(--lt-brand, #0877bc);\n}\n\n.lt-settings-dialog__subsection {\n  padding: 10px 10px 6px;\n  margin: 0 0 12px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--lt-brand-secondary, #46528b) 12%, rgba(15, 23, 42, 0.35));\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 22%, rgba(255, 255, 255, 0.08));\n}\n\n.lt-settings-dialog__subsection:last-child {\n  margin-bottom: 0;\n}\n\n.lt-settings-dialog__subsection-title {\n  margin: 0 0 8px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #f8fafc);\n}\n\n.light-mode .lt-settings-dialog__subsection,\nhtml[data-theme=\"light\"] .lt-settings-dialog__subsection {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 5%, #ffffff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 20%, #cbd5e1);\n}\n\n.light-mode .lt-settings-dialog__subsection-title,\nhtml[data-theme=\"light\"] .lt-settings-dialog__subsection-title {\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-settings-dialog .MuiSwitch-switchBase.Mui-checked {\n  color: var(--lt-brand, #0877bc) !important;\n}\n\n.lt-settings-dialog .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {\n  background-color: var(--lt-brand, #0877bc) !important;\n}\n\n.lt-settings-dialog__switch {\n  align-items: flex-start !important;\n  margin: 0 0 var(--lt-settings-gap, 12px) !important;\n  width: 100%;\n  gap: 4px;\n}\n\n.lt-settings-dialog__switch .MuiFormControlLabel-label {\n  margin-left: 2px;\n  min-width: 0;\n}\n\n.lt-settings-dialog__switch .MuiSwitch-root {\n  margin-top: -2px;\n}\n\n.lt-settings-dialog__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.lt-settings-dialog__field + .lt-settings-dialog__field {\n  margin-top: 14px;\n}\n\n.lt-settings-dialog__field--disabled {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.lt-settings-dialog__label {\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.lt-settings-dialog__hint {\n  display: block;\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.35;\n  opacity: 0.75;\n}\n\n.lt-settings-dialog__select {\n  appearance: none;\n  width: 100%;\n  max-width: 100%;\n  margin-top: 2px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid\n    color-mix(in srgb, var(--lt-brand, #0877bc) 32%, rgba(255, 255, 255, 0.18));\n  background: rgba(15, 23, 42, 0.6);\n  color: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.lt-settings-dialog__select:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--lt-brand, #0877bc) 75%, #fff);\n  outline-offset: 2px;\n}\n\n.lt-settings-dialog__select:disabled {\n  cursor: not-allowed;\n}\n\n.lt-settings-dialog__table-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.lt-settings-dialog__table-chip {\n  position: relative;\n  min-width: 44px;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 12px;\n  border: 1px dashed\n    color-mix(in srgb, var(--lt-brand, #0877bc) 40%, rgba(255, 255, 255, 0.28));\n  background: rgba(15, 23, 42, 0.45);\n  color: rgba(248, 250, 252, 0.78);\n  font: inherit;\n  font-size: 15px;\n  font-weight: 750;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n.lt-settings-dialog__table-chip:active {\n  transform: scale(0.96);\n}\n\n.lt-settings-dialog__table-chip:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--lt-brand, #0877bc) 75%, #fff);\n  outline-offset: 2px;\n}\n\n.lt-settings-dialog__table-chip.is-on {\n  border-style: solid;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #ffffff);\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  box-shadow: 0 2px 8px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);\n}\n\n.lt-settings-dialog__table-chip.is-main {\n  border-color: #facc15;\n  box-shadow: 0 0 0 1px rgba(250, 204, 21, 0.45);\n}\n\n.lt-settings-dialog__table-chip.is-main::after {\n  content: \"★\";\n  position: absolute;\n  top: 1px;\n  right: 4px;\n  font-size: 9px;\n  color: #facc15;\n}\n\n.lt-settings-dialog__table-chip--all {\n  border-style: solid;\n  font-size: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.lt-settings-dialog__forced-banner {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, transparent);\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n\n.lt-settings-dialog__actions .MuiButton-contained {\n  background: var(--lt-brand, #0877bc) !important;\n  color: #ffffff !important;\n}\n\n/* Light mode — Live Training settings */\n.light-mode .lt-settings-dialog .lt-settings-dialog__paper,\nhtml[data-theme=\"light\"] .lt-settings-dialog .lt-settings-dialog__paper {\n  background: linear-gradient(\n    165deg,\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 8%, #f8fafc) 0%,\n    #ffffff 55%,\n    #f1f5f9 100%\n  );\n  color: #0f172a;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 24%, #cbd5e1);\n  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.16);\n}\n\n.light-mode .lt-settings-dialog__title.MuiDialogTitle-root,\n.light-mode .lt-settings-dialog__section + .lt-settings-dialog__section,\nhtml[data-theme=\"light\"] .lt-settings-dialog__title.MuiDialogTitle-root,\nhtml[data-theme=\"light\"] .lt-settings-dialog__section + .lt-settings-dialog__section {\n  border-color: rgba(15, 23, 42, 0.1);\n}\n\n.light-mode .lt-settings-dialog__section-title,\nhtml[data-theme=\"light\"] .lt-settings-dialog__section-title {\n  color: var(--lt-brand, #0877bc);\n}\n\n.light-mode .lt-settings-dialog__select,\nhtml[data-theme=\"light\"] .lt-settings-dialog__select {\n  background: #ffffff;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-settings-dialog__table-chip:not(.is-on),\nhtml[data-theme=\"light\"] .lt-settings-dialog__table-chip:not(.is-on) {\n  background: #f8fafc;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, #cbd5e1);\n  color: #334155;\n}\n\n.light-mode .lt-settings-dialog__actions.MuiDialogActions-root,\nhtml[data-theme=\"light\"] .lt-settings-dialog__actions.MuiDialogActions-root {\n  background: rgba(248, 250, 252, 0.94);\n  border-top-color: rgba(15, 23, 42, 0.1);\n}\n\n.lt-settings-dialog__fields-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  align-items: start;\n}\n\n.lt-settings-dialog__fields-row > .lt-settings-dialog__field {\n  margin-top: 0;\n}\n\n.lt-settings-dialog__fields-row > .lt-settings-dialog__field + .lt-settings-dialog__field {\n  margin-top: 0;\n}\n\n@media (min-width: 520px) {\n  .lt-settings-dialog__fields-row {\n    grid-template-columns: 1fr 1fr;\n    gap: 12px 16px;\n  }\n}\n\n/* Narrow phones / short portrait — keep actions reachable */\n@media (max-width: 380px), (max-height: 560px) and (orientation: portrait) {\n  .lt-settings-dialog__title.MuiDialogTitle-root {\n    padding: 12px 14px 6px;\n    font-size: 1.02rem;\n  }\n\n  .lt-settings-dialog__content.MuiDialogContent-root {\n    padding: 8px 14px 10px !important;\n  }\n\n  .lt-settings-dialog__actions.MuiDialogActions-root {\n    padding: 8px 10px calc(8px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .lt-settings-dialog__actions .MuiButton-root {\n    min-height: 38px;\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
